export type ReceiptSearchTargetValue = (typeof ReceiptSearchTargetValue)[keyof typeof ReceiptSearchTargetValue];
export const ReceiptSearchTargetValue = {
  /** 航空券 */
  ETICKET: 0,
  /** EMD */
  EMD: 1,
} as const;
